import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button';
import Form from 'components/Form';
import FormRow from 'components/FormRow';
import Textbox from 'components/Textbox/index';
import moment from "moment/moment";

export default class AlgorithmForm extends React.Component {
    static propTypes = {
        algorithm: PropTypes.object.isRequired,
        handleResetForm: PropTypes.func.isRequired,
        isSaving: PropTypes.bool,
        openEditModal: PropTypes.func.isRequired,
    };

    constructor() {
        super();

        this.dataPoints = [
            {
                id: "txtTotalMixedRation_alfalfaHayPricePerTon",
                label: "Total Mixed Ration Alfalfa hay Price per Ton",
                name: "totalMixedRation_alfalfaHayPricePerTon"
            }, {
                id: "txtTotalMixedRation_mineralMixPricePerTon",
                label: "Total Mixed Ration Mineral mix Price per Ton",
                name: "totalMixedRation_mineralMixPricePerTon"
            }, {
                id: "txtTotalMixedRation_dryCowFeedCostPerCwt",
                label: "Total Mixed Ration dry cow Feed Cost per CWT",
                name: "totalMixedRation_dryCowFeedCostPerCwt"
            }, {
                id: "txtTotalMixedRation_heiferFeedCostPerCwt",
                label: "Total Mixed Ration Heifer Feed Cost per CWT",
                name: "totalMixedRation_heiferFeedCostPerCwt"
            }, {
                id: "txtIncomePerCwt_calvesHeifers",
                label: "Income per CWT Calves and Heifers",
                name: "incomePerCwt_calvesHeifers"
            }, {
                id: "txtIncomePerCwt_patronageDividends",
                label: "Income per CWT Patronage and Dividends",
                name: "incomePerCwt_patronageDividends"
            }, {
                id: "txtIncomePerCwt_other",
                label: "Income per CWT Other",
                name: "incomePerCwt_other"
            }, {
                id: "txtHerdReplacement_cowDepreciation",
                label: "Herd Replacement cow Depreciation",
                name: "herdReplacement_cowDepreciation"
            }, {
                id: "txtHerdReplacement_lossOnSaleOfCows",
                label: "Herd Replacement Loss on Sale of Cows",
                name: "herdReplacement_lossOnSaleOfCows"
            }, {
                id: "txtOperatingExpenses_interestRent",
                label: "Operating Expenses Interest Rent",
                name: "operatingExpenses_interestRent"
            }, {
                id: "txtOperatingExpenses_equipmentLease",
                label: "Operating Expenses Equipment Lease",
                name: "operatingExpenses_equipmentLease"
            }, {
                id: "txtOperatingExpenses_labor",
                label: "Operating Expenses Labor",
                name: "operatingExpenses_labor"
            }, {
                id: "txtOperatingExpenses_otherDepreciation",
                label: "Operating Expenses Other Depreciation",
                name: "operatingExpenses_otherDepreciation"
            }, {
                id: "txtOperatingExpenses_milkHauling",
                label: "Operating Expenses Milk Hauling",
                name: "operatingExpenses_milkHauling"
            }, {
                id: "txtOperatingExpenses_industryAssessments",
                label: "Operating Expenses Industry Assessments",
                name: "operatingExpenses_industryAssessments"
            }, {
                id: "txtOperatingExpenses_supplies",
                label: "Operating Expenses Supplies",
                name: "operatingExpenses_supplies"
            }, {
                id: "txtOperatingExpenses_bst",
                label: "Operating Expenses BST",
                name: "operatingExpenses_bst"
            }, {
                id: "txtOperatingExpenses_manureManagement",
                label: "Operating Expenses Manure Management",
                name: "operatingExpenses_manureManagement"
            }, {
                id: "txtOperatingExpenses_repairsMaintenance",
                label: "Operating Expenses Repairs and Maintenance",
                name: "operatingExpenses_repairsMaintenance"
            }, {
                id: "txtOperatingExpenses_utilities",
                label: "Operating Expenses Utilities",
                name: "operatingExpenses_utilities"
            }, {
                id: "txtOperatingExpenses_taxesLicenses",
                label: "Operating Expenses Taxes and Licenses",
                name: "operatingExpenses_taxesLicenses"
            }, {
                id: "txtOperatingExpenses_insurance",
                label: "Operating Expenses Insurance",
                name: "operatingExpenses_insurance"
            }, {
                id: "txtOperatingExpenses_fuelAndOil",
                label: "Operating Expenses Fuel and Oil",
                name: "operatingExpenses_fuelAndOil"
            }, {
                id: "txtOperatingExpenses_legalAccounting",
                label: "Operating Expenses Legal and Accounting",
                name: "operatingExpenses_legalAccounting"
            }, {
                id: "txtOperatingExpenses_employeeBenefits",
                label: "Operating Expenses Employee Benefits",
                name: "operatingExpenses_employeeBenefits"
            }, {
                id: "txtOperatingExpenses_veterinaryBreeding",
                label: "Operating Expenses Veterinary Breeding",
                name: "operatingExpenses_veterinaryBreeding"
            }, {
                id: "txtOperatingExpenses_testingTrimming",
                label: "Operating Expenses Testing and Trimming",
                name: "operatingExpenses_testingTrimming"
            }, {
                id: "txtOperatingExpenses_haulingLivestock",
                label: "Operating Expenses Hauling Livestock",
                name: "operatingExpenses_haulingLivestock"
            }, {
                id: "txtOperatingExpenses_miscellaneous",
                label: "Operating Expenses Miscellaneous",
                name: "operatingExpenses_miscellaneous"
            }, {
                id: "txtOperatingExpenses_costOfRaisingHeifers",
                label: "Operating Expenses Cost of Raising Heifers",
                name: "operatingExpenses_costOfRaisingHeifers"
            }, {
                id: "txtExpenseMultiplier_250cows",
                label: "Expense Multiplier for 250 Cows",
                name: "expenseMultiplier_250cows"
            }, {
                id: "txtExpenseMultiplier_1500cows",
                label: "Expense Multiplier for 1,500 Cows",
                name: "expenseMultiplier_1500cows"
            }
        ]
    }

    render() {
        let { algorithm } = this.props;

        return (
            <Form className="algorithm-form">
                <FormRow>
                    Last Change: {moment(this.props.algorithm.updated_at).format('M/D/YYYY')}
                </FormRow>

                {this.dataPoints.map((dp, index) => {
                    return (
                        <FormRow key={index}>
                            <Textbox
                                disabled={true}
                                id={dp.id}
                                label={dp.label}
                                name={dp.name}
                                type="number"
                                value={algorithm[dp.name] || ''}
                            />
                            <Button noStyles
                                    onClick={this.props.openEditModal.bind(this, dp)}
                                    type="button">
                                <img src="/img/icon--pencil.svg" alt="Edit" />
                            </Button>
                        </FormRow>
                    );
                })}
            </Form>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/AlgorithmPage/AlgorithmForm.js